import { createMiddleware } from "@tanstack/react-start";

import { supabase } from "@/integrations/supabase/client";

/**
 * Anexa o token da sessão às chamadas de função de servidor protegidas.
 * O guarda do servidor (requireSupabaseAuth) exige o cabeçalho Authorization.
 */
export const attachSupabaseAuth = createMiddleware({ type: "function" }).client(async ({ next }) => {
  if (typeof window === "undefined") return next();

  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  if (!token) return next();

  return next({ headers: { Authorization: `Bearer ${token}` } });
});
